import { Badge, type BadgeTone } from '@wundo/ui';
import { organisationTypeLabel } from '@/lib/organisations.ts';

/*
 * One tone per kind, so the same word is the same colour on the list and on the
 * detail page. `internal` is the navy one because it is us; `business` is the
 * accent because it is the paying case; `academy` has nothing to say about
 * itself and stays neutral.
 */
const TONES: Record<string, BadgeTone> = {
  internal: 'info',
  academy: 'neutral',
  business: 'success',
};

export function OrganisationTypeBadge({ type }: { type: string }) {
  return <Badge tone={TONES[type] ?? 'neutral'}>{organisationTypeLabel(type)}</Badge>;
}
